document.querySelectorAll('[data-end]').forEach((clock) => {
  const end = new Date(clock.dataset.end).getTime();
  const values = {
    days: clock.querySelector('[data-days]'),
    hours: clock.querySelector('[data-hours]'),
    minutes: clock.querySelector('[data-minutes]'),
    seconds: clock.querySelector('[data-seconds]')
  };
  const update = () => {
    const remaining = Math.max(0, end - Date.now());
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    values.days.textContent = String(days).padStart(2, '0');
    values.hours.textContent = String(hours).padStart(2, '0');
    values.minutes.textContent = String(minutes).padStart(2, '0');
    values.seconds.textContent = String(seconds).padStart(2, '0');
  };
  update();
  window.setInterval(update, 1000);
});
